export const QUOTATION_LANGUAGES = [
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'en', label: 'English', flag: '🇬🇧' }
];

export const DEFAULT_LABELS_NL = {
  client: 'Opdrachtgever',
  reference: 'Referentie',
  date: 'Offertedatum',
  validUntil: 'Vervaldatum',
  seller: 'Verkoper',
  description: 'OMSCHRIJVING',
  quantity: 'AANTAL',
  price: 'PRIJS',
  vat: 'BTW',
  amount: 'BEDRAG',
  total: 'Totaal',
  paymentTerms: 'Betaling',
  greeting: 'Aanhef',
  investment: 'Investering',
  highlightBoxTitle: 'Kern van het aanbod',
  closingGreeting: 'Afsluiting',
  productsSectionTitle: 'Producten & Diensten',
  clientDataSectionTitle: 'Opdrachtgever',
  fixedPrice: 'Vaste prijs',
  oneTime: 'Eenmalig',
  monthly: 'Maandelijks',
  payment: 'Betaling'
};

export const DEFAULT_LABELS_EN = {
  client: 'Client',
  reference: 'Reference',
  date: 'Quotation date',
  validUntil: 'Valid until',
  seller: 'Sales representative',
  description: 'DESCRIPTION',
  quantity: 'QTY',
  price: 'PRICE',
  vat: 'VAT',
  amount: 'AMOUNT',
  total: 'Total',
  paymentTerms: 'Payment',
  greeting: 'Salutation',
  investment: 'Investment',
  highlightBoxTitle: 'Core of the offer',
  closingGreeting: 'Closing',
  productsSectionTitle: 'Products & Services',
  clientDataSectionTitle: 'Client details',
  fixedPrice: 'Fixed price',
  oneTime: 'One-time',
  monthly: 'Monthly',
  payment: 'Payment'
};

export const FIELD_LABEL_KEYS = [
  { key: 'client', labelNl: 'Klant / opdrachtgever', placeholderNl: 'Opdrachtgever', placeholderEn: 'Client' },
  { key: 'reference', labelNl: 'Referentie', placeholderNl: 'Referentie', placeholderEn: 'Reference' },
  { key: 'date', labelNl: 'Datum', placeholderNl: 'Datum', placeholderEn: 'Quotation date' },
  { key: 'validUntil', labelNl: 'Vervaldatum', placeholderNl: 'Vervaldatum', placeholderEn: 'Valid until' },
  { key: 'seller', labelNl: 'Verkoper', placeholderNl: 'Verkoper', placeholderEn: 'Sales representative' },
  { key: 'description', labelNl: 'Omschrijving (tabel)', placeholderNl: 'OMSCHRIJVING', placeholderEn: 'DESCRIPTION' },
  { key: 'quantity', labelNl: 'Aantal', placeholderNl: 'AANTAL', placeholderEn: 'QTY' },
  { key: 'price', labelNl: 'Prijs', placeholderNl: 'PRIJS', placeholderEn: 'PRICE' },
  { key: 'vat', labelNl: 'BTW', placeholderNl: 'BTW', placeholderEn: 'VAT' },
  { key: 'amount', labelNl: 'Bedrag', placeholderNl: 'BEDRAG', placeholderEn: 'AMOUNT' },
  { key: 'total', labelNl: 'Totaal', placeholderNl: 'Totaal', placeholderEn: 'Total' },
  { key: 'paymentTerms', labelNl: 'Betaling', placeholderNl: 'Betaling', placeholderEn: 'Payment' },
  { key: 'greeting', labelNl: 'Aanhef', placeholderNl: 'Aanhef', placeholderEn: 'Salutation' },
  { key: 'investment', labelNl: 'Investering', placeholderNl: 'Investering', placeholderEn: 'Investment' },
  { key: 'clientDataSectionTitle', labelNl: 'Gegevens opdrachtgever (sectietitel)', placeholderNl: 'Gegevens opdrachtgever', placeholderEn: 'Client details' },
  { key: 'productsSectionTitle', labelNl: 'Producten & diensten (sectietitel)', placeholderNl: 'Producten & Diensten', placeholderEn: 'Products & Services' },
  { key: 'highlightBoxTitle', labelNl: 'Kern van het aanbod (highlight)', placeholderNl: 'Kern van het aanbod', placeholderEn: 'Core of the offer' },
  { key: 'closingGreeting', labelNl: 'Afsluiting', placeholderNl: 'Met vriendelijke groet', placeholderEn: 'Closing' },
  { key: 'fixedPrice', labelNl: 'Vaste prijs (investering)', placeholderNl: 'Vaste prijs', placeholderEn: 'Fixed price' },
  { key: 'oneTime', labelNl: 'Eenmalig (investering)', placeholderNl: 'Eenmalig', placeholderEn: 'One-time' },
  { key: 'monthly', labelNl: 'Maandelijks (investering)', placeholderNl: 'Maandelijks', placeholderEn: 'Monthly' },
  { key: 'payment', labelNl: 'Betaling (investering)', placeholderNl: 'Betaling', placeholderEn: 'Payment' }
];

export const DEFAULT_PRICING_BY_LANGUAGE = {
  nl: {
    subtitle: 'excl. btw',
    paymentTerms: '40% / 60%',
    paymentDescription: '40% aanbetaling bij akkoord • 60% bij oplevering'
  },
  en: {
    subtitle: 'excl. VAT',
    paymentTerms: '40% / 60%',
    paymentDescription: '40% deposit upon agreement • 60% upon delivery'
  }
};

export const DEFAULT_STATIC_TEXTS_EN = {
  greeting: 'Dear Sir/Madam,\n\nThank you for your interest. Please find enclosed our quotation for the requested work. We have carefully reviewed your request and prepared a tailored proposal. We would be happy to explain the scope and investment in this quotation in more detail. If you have any questions, please do not hesitate to contact us.',
  description: 'We have calculated the assignment and present below an overview of the work and the investment. Our work is carried out with professional materials and skilled finishing. We stand for quality and durability. The prices stated are based on the information you provided and our standard terms of execution. Any additional work or changes can be quoted separately.',
  highlight: 'Our quotation is clear and all-inclusive. We ensure neat finishing and cleanup. If you have questions, we are happy to help. The timelines mentioned are indicative; upon agreement we will align the planning with you. We work with durable materials and aim for a result you will enjoy for years.',
  closing: 'Do you have questions or would you like to discuss this quotation? Please feel free to contact us. We hope to be of service to you soon. You can reach us by email or phone; we usually respond within one business day. We look forward to bringing this project to a successful completion together with you.'
};

export const DEFAULT_SIGNATURE_NL = 'Met vriendelijke groet,';
export const DEFAULT_SIGNATURE_EN = 'Kind regards,';

export function normalizeQuotationLanguage(language) {
  return language === 'en' ? 'en' : 'nl';
}

export function getLocaleForLanguage(language) {
  return normalizeQuotationLanguage(language) === 'en' ? 'en-GB' : 'nl-NL';
}

export function formatQuotationDate(language, date = new Date()) {
  return date.toLocaleDateString(getLocaleForLanguage(language));
}

export function getQuotationLabels(language, customNl = {}, customEn = {}) {
  const lang = normalizeQuotationLanguage(language);
  const defaults = lang === 'en' ? DEFAULT_LABELS_EN : DEFAULT_LABELS_NL;
  const custom = lang === 'en' ? customEn : customNl;
  const merged = { ...defaults };
  Object.entries(custom || {}).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== '') merged[key] = value;
  });
  return merged;
}

function isKnownPricingValue(value, field) {
  return Object.values(DEFAULT_PRICING_BY_LANGUAGE).some((pricing) => pricing[field] === value);
}

export function applyLanguageToQuotationData(prev, newLanguage) {
  const lang = normalizeQuotationLanguage(newLanguage);
  const pricingDefaults = DEFAULT_PRICING_BY_LANGUAGE[lang];
  const nextPricing = { ...prev.pricing };

  if (!prev.pricing?.subtitle || isKnownPricingValue(prev.pricing.subtitle, 'subtitle')) {
    nextPricing.subtitle = pricingDefaults.subtitle;
  }
  if (!prev.pricing?.paymentTerms || isKnownPricingValue(prev.pricing.paymentTerms, 'paymentTerms')) {
    nextPricing.paymentTerms = pricingDefaults.paymentTerms;
  }
  if (!prev.pricing?.paymentDescription || isKnownPricingValue(prev.pricing.paymentDescription, 'paymentDescription')) {
    nextPricing.paymentDescription = pricingDefaults.paymentDescription;
  }

  let companyContact = prev.companyContact || '';
  if (lang === 'en' && companyContact.startsWith(DEFAULT_SIGNATURE_NL)) {
    companyContact = companyContact.replace(DEFAULT_SIGNATURE_NL, DEFAULT_SIGNATURE_EN);
  } else if (lang === 'nl' && companyContact.startsWith(DEFAULT_SIGNATURE_EN)) {
    companyContact = companyContact.replace(DEFAULT_SIGNATURE_EN, DEFAULT_SIGNATURE_NL);
  }

  return {
    ...prev,
    language: lang,
    date: formatQuotationDate(lang),
    pricing: nextPricing,
    companyContact
  };
}
